import { render, staticRenderFns } from "./AccountCreated.vue?vue&type=template&id=72421e76&"
import script from "./AccountCreated.vue?vue&type=script&lang=js&"
export * from "./AccountCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports